module.exports = __webpack_public_path__ + "img/fengge.369cb546.svg";